// src/data/mock.js
// Mock data for A Gentle Touch HomeCare

import teairaPannellPhoto from "@/assets/teaira-pannell.jpg";

export const companyInfo = {
  name: "A Gentle Touch HomeCare",
  tagline: "When a Gentle Touch, Can Mean So Much",
  email: "agentletouchhomecarellc1@gmail.com",
  address: "Ohio",
  logo: "https://customer-assets.emergentagent.com/job_google-business-link/artifacts/ubw6bbrl_Untitled%20design%20%2841%29.png",
};

export const missionStatement = `At A Gentle Touch HomeCare, we provide compassionate, dependable, and personalized non medical in home care and companionship for aging adults. Our mission is to support each individual's independence, safety, and dignity, helping them live comfortably and confidently in the home they love.`;

export const services = [
  {
    id: 1,
    title: "Companionship",
    description:
      "Friendly conversation, emotional support, and engaging activities to combat loneliness and promote mental wellness.",
    image:
      "https://customer-assets.emergentagent.com/job_c4b9ca64-b237-4933-8366-cab315d156d4/artifacts/twc5045f_1072feea-dba8-476c-b8dd-0459cdb0da69.jpg",
    slug: "companionship",
  },
  {
    id: 2,
    title: "Personal Care",
    description:
      "Compassionate assistance with bathing, dressing, grooming, and daily living activities to maintain dignity and comfort.",
    image:
      "https://customer-assets.emergentagent.com/job_ef554099-1419-4ed6-b2eb-4354172ecbee/artifacts/pkytbi90_bcd52855-e169-4b34-9024-04561d08a1cb.jpg",
    slug: "personal-care",
  },
  {
    id: 3,
    title: "Medication Reminders",
    description:
      "Timely and reliable reminders to help your loved one stay on track with their medication schedule for optimal health.",
    image:
      "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=600&q=80",
    slug: "medication-reminders",
  },
  {
    id: 4,
    title: "Light Housekeeping",
    description:
      "Maintaining a clean, safe, and organized living environment including laundry, dishes, and general tidying.",
    image:
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&q=80",
    slug: "light-housekeeping",
  },
  {
    id: 5,
    title: "Meal Preparation",
    description:
      "Nutritious meal planning and preparation tailored to dietary needs and personal preferences.",
    image:
      "https://customer-assets.emergentagent.com/job_7a331937-4ddf-45f8-891f-185184b2c0e4/artifacts/damvlugc_pexels-kampus-7551594.jpg",
    slug: "meal-preparation",
  },
  {
    id: 6,
    title: "Respite Care",
    description:
      "Providing family caregivers with much needed breaks while ensuring continuous quality care for your loved one.",
    image:
      "https://customer-assets.emergentagent.com/job_7a331937-4ddf-45f8-891f-185184b2c0e4/artifacts/f21iev9o_pexels-olly-3768131.jpg",
    slug: "respite-care",
  },
  {
    id: 7,
    title: "Alzheimer's & Dementia Care",
    description:
      "Compassionate, non medical support for individuals living with Alzheimer's disease and other forms of dementia, emphasizing patience and structured routines.",
    image:
      "https://customer-assets.emergentagent.com/job_27a89650-5e93-4443-a640-b7820d6d24a5/artifacts/t2pkur3o_pexels-kampus-7551606.jpg",
    slug: "alzheimers-dementia-care",
  },
];

// Full service page content
export const servicePageContent = {
  "personal-care": {
    title: "Personal Care Services",
    heroImage: "https://customer-assets.emergentagent.com/job_c4b9ca64-b237-4933-8366-cab315d156d4/artifacts/itlka4qt_gmm4dwah_Screenshot%202026-01-12%20at%209.17.32%E2%80%AFAM.png",
    intro: "At A Gentle Touch HomeCare, our Personal Care services are provided with compassion, respect, and a commitment to preserving independence and dignity. We understand that personal care is deeply personal, and our caregivers approach each client with patience, sensitivity, and kindness.",
    subIntro: "Services are individualized to meet daily needs while supporting comfort and safety in the home.",
    listTitle: "Personal Care services may include:",
    listItems: [
      "Assistance with bathing, grooming, and hygiene",
      "Help with dressing and personal appearance",
      "Toileting and incontinence support",
      "Mobility and transfer assistance",
      "General safety monitoring"
    ],
    disclosure: "Disclosure: Personal Care services provided by A Gentle Touch HomeCare are non medical and do not include skilled nursing or medical treatments."
  },
  "medication-reminders": {
    title: "Medication Reminders",
    heroImage: "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=1200&q=80",
    intro: "Our Medication Reminder services are designed to support daily routines and promote independence while offering peace of mind to clients and families.",
    subIntro: "Caregivers provide gentle reminders and oversight to help clients stay on schedule with prescribed medications.",
    listTitle: "Medication Reminder services may include:",
    listItems: [
      "Verbal or written reminders to take medications",
      "Assistance with opening medication containers (non medical)",
      "Monitoring for missed doses",
      "Communicating concerns to family or authorized contacts"
    ],
    disclosure: "Disclosure: Medication Reminders are non medical. Caregivers do not administer, measure, or manage medications."
  },
  "light-housekeeping": {
    title: "Light Housekeeping",
    heroImage: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&q=80",
    intro: "A safe and comfortable home environment is essential to well being. Our Light Housekeeping services help maintain a clean, organized living space that supports independence and reduces safety risks.",
    subIntro: "Tasks are limited to routine household upkeep and performed with care and respect for the client's home.",
    listTitle: "Light Housekeeping services may include:",
    listItems: [
      "Sweeping, vacuuming, and dusting",
      "Laundry and linen changes",
      "Dishwashing and surface cleaning",
      "Trash removal and light organization",
      "Maintaining clutter free walkways"
    ],
    disclosure: "Disclosure: Light Housekeeping services are non medical and do not include deep cleaning or maintenance work."
  },
  "meal-preparation": {
    title: "Meal Preparation",
    heroImage: "https://customer-assets.emergentagent.com/job_7a331937-4ddf-45f8-891f-185184b2c0e4/artifacts/damvlugc_pexels-kampus-7551594.jpg",
    intro: "Our Meal Preparation services focus on nourishing the body while honoring personal preferences, routines, and cultural traditions. Caregivers assist with preparing simple, balanced meals that support daily wellness.",
    subIntro: "We aim to make mealtime enjoyable, comfortable, and stress free.",
    listTitle: "Meal Preparation services may include:",
    listItems: [
      "Planning and preparing meals",
      "Serving meals and cleanup",
      "Assistance during meals (non medical)",
      "Grocery list support",
      "Kitchen tidying after use"
    ],
    disclosure: "Disclosure: Meal Preparation services are non medical and do not include medical nutrition therapy or dietary prescriptions."
  },
  "respite-care": {
    title: "Respite Care",
    heroImage: "https://customer-assets.emergentagent.com/job_7a331937-4ddf-45f8-891f-185184b2c0e4/artifacts/f21iev9o_pexels-olly-3768131.jpg",
    intro: "Caring for a loved one is rewarding but can also be physically and emotionally demanding. Our Respite Care services provide dependable, compassionate care while family caregivers take time to rest, recharge, or attend to personal responsibilities.",
    subIntro: "We ensure continuity of care in a safe and familiar environment.",
    listTitle: "Respite Care services may include:",
    listItems: [
      "Supervision and companionship",
      "Personal care assistance",
      "Meal preparation and light housekeeping",
      "Medication reminders",
      "Routine and safety monitoring"
    ],
    disclosure: "Disclosure: Respite Care services are non medical and are intended to provide temporary support, not skilled medical care."
  },
  "alzheimers-dementia-care": {
    title: "Alzheimer's & Dementia Care",
    heroImage: "https://customer-assets.emergentagent.com/job_27a89650-5e93-4443-a640-b7820d6d24a5/artifacts/t2pkur3o_pexels-kampus-7551606.jpg",
    intro: "At A Gentle Touch HomeCare, we offer compassionate, non medical support for individuals living with Alzheimer's disease and other forms of dementia. Our approach emphasizes patience, reassurance, and structured routines to promote comfort and familiarity.",
    subIntro: "We strive to enhance quality of life while supporting families through every stage of the journey.",
    listTitle: "Alzheimer's & Dementia Care services may include:",
    listItems: [
      "Consistent daily routines",
      "Gentle redirection and reassurance",
      "Memory supportive activities",
      "Personal care assistance",
      "Safety supervision and companionship"
    ],
    disclosure: "Disclosure: Alzheimer's and Dementia Care services are non medical and do not include diagnosis, treatment, or skilled nursing care."
  },
  "companionship": {
    title: "Companionship Services",
    heroImage: "https://customer-assets.emergentagent.com/job_c4b9ca64-b237-4933-8366-cab315d156d4/artifacts/twc5045f_1072feea-dba8-476c-b8dd-0459cdb0da69.jpg",
    intro: "At A Gentle Touch HomeCare, our Companionship services focus on nurturing emotional well being, meaningful connection, and a sense of belonging. We believe compassionate presence and genuine conversation are essential to maintaining dignity and quality of life.",
    subIntro: "Our caregivers provide dependable companionship while encouraging independence, engagement, and comfort in the familiar surroundings of home.",
    listTitle: "Companionship services may include:",
    listItems: [
      "Friendly conversation and emotional support",
      "Shared activities such as reading, games, or hobbies",
      "Accompaniment on walks or outings",
      "Meal companionship and encouragement",
      "General supervision and well being checks"
    ],
    disclosure: "Disclosure: Companionship services provided by A Gentle Touch HomeCare are non medical and do not include skilled nursing care, medical treatments, or clinical supervision."
  }
};

export const coreValues = [
  {
    letter: "C",
    title: "Compassion",
    description:
      "We deliver care with empathy, professionalism, and respect for each client's physical, emotional, and social needs.",
  },
  {
    letter: "A",
    title: "Attitude",
    description:
      "We uphold accountability, honesty, integrity, and professionalism in all responsibilities and interactions.",
  },
  {
    letter: "R",
    title: "Respect",
    description:
      "We honor the dignity, rights, cultural backgrounds, and personal preferences of every client, family, and employee.",
  },
  {
    letter: "E",
    title: "Excellence",
    description:
      "We are committed to continuous quality improvement, caregiver training, supervision, and high standards of service delivery.",
  },
];

export const whyChooseUs = [
  {
    title: "Personalized Care Plans",
    description:
      "Every care plan is tailored to meet the unique needs and preferences of each individual client.",
  },
  {
    title: "Trained & Compassionate Caregivers",
    description:
      "Our caregivers undergo thorough background checks and receive ongoing professional training.",
  },
  {
    title: "Flexible Scheduling",
    description:
      "We offer flexible care schedules throughout the week and weekends.",
  },
  {
    title: "Local & Trusted",
    description:
      "Proudly serving families in Ohio with dedication and a commitment to community.",
  },
];

export const paymentMethods = [
  { name: "ACH Payments", icon: "Building" },
  { name: "Debit Card", icon: "CreditCard" },
  { name: "Zelle", icon: "Smartphone" },
];

export const paymentLink =
  "https://7f6c926f-fb45-4482-b9ec-9727c4ad3858.paylinks.godaddy.com/de38e090-9528-42dd-84d3-181";

// Navigation EXACTLY as requested:
// Home, About Us, Services, Payments, Contact, Apply
// About Us goes to the About Me PAGE (/about-me)
// Services is now a page link (/services)
// Payments is EXTERNAL link (opens GoDaddy pay link)
export const googleBusinessUrl = "https://share.google/iAmeuJszWMXEvjhiC";

export const navigation = [
  { name: "Home", href: "/", isPage: true },
  { name: "About Us", href: "/about-me", isPage: true },
  { name: "Services", href: "/services", isPage: true },
  { name: "Payments", href: paymentLink, external: true },
  { name: "Reviews", href: googleBusinessUrl, external: true },
  { name: "Contact", href: "/contact", isPage: true },
  { name: "Apply", href: "/apply", isPage: true },
];

export const aboutMeContent = {
  title: "About Me",
  content: `Hello, and welcome. My name is Teaira Pannell, Owner and Care Provider of A Gentle Touch HomeCare.

I am a dedicated mother of two and a compassionate caregiver with over a decade of experience in the non medical home care field. I began my journey as a Home Health Aide in 2013, where I discovered my true calling, serving others with patience, dignity, and love. Over the years, I have had the privilege of supporting aging adults and families during some of life's most important moments, and that experience inspired me to establish A Gentle Touch HomeCare.

At the heart of my work is faith, compassion, and purpose. I believe caregiving is more than a service. It is a ministry of kindness, trust, and respect. I strive to treat every client as I would want my own loved ones treated: with warmth, dependability, and genuine care.

A Gentle Touch HomeCare was founded to provide high quality, individualized, non medical in home care and companionship services that allow aging adults to remain safe, comfortable, and independent in their own homes. My goal is to create peace of mind for families while enhancing the quality of life for those we serve.

I am committed to professionalism, integrity, and continuous learning to ensure the highest standard of care. Whether assisting with companionship, daily activities, or personal support, I approach every client relationship with humility, empathy, and a servant's heart.`,
  quote:
    '"Whatever you do, work at it with all your heart, as working for the Lord." — Colossians 3:23',
  closing:
    "Thank you for trusting A Gentle Touch HomeCare. It would be an honor to serve you or your loved one.",
};

export const videos = {
  hero: "https://customer-assets.emergentagent.com/job_7a331937-4ddf-45f8-891f-185184b2c0e4/artifacts/z8ncazrq_7517699-uhd_3840_2160_25fps.mp4",
  about:
    "https://customer-assets.emergentagent.com/job_ef554099-1419-4ed6-b2eb-4354172ecbee/artifacts/2novd24m_7517376-uhd_3840_2160_25fps.mp4",
  services:
    "https://customer-assets.emergentagent.com/job_ef554099-1419-4ed6-b2eb-4354172ecbee/artifacts/2novd24m_7517376-uhd_3840_2160_25fps.mp4",
  companionship:
    "https://customer-assets.emergentagent.com/job_gentle-touch-2/artifacts/lkmbgxgg_7516763-uhd_2160_3840_25fps.mp4",
};

export const ownerPhoto = teairaPannellPhoto;
